import { makeStyles } from '@material-ui/core/styles';
import { colorMap, ColorNames, SecondaryColors, TextColors } from '@/utils/constants';

const darkTheme = {
  buttonLabel: {
    color: TextColors.light,
  },
  root: {
    '& .MuiButton-startIcon svg path': {
      stroke: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  buttonLabel: {
    color: colorMap[ColorNames.charcoal],
  },
  root: {
    '& .MuiButton-startIcon svg path': {
      stroke: SecondaryColors.dark,
    },
  },
};

const useBackButtonNavigationStyles = makeStyles(
  (theme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      padding: theme.spacing(0.5, 1),
      marginLeft: theme.spacing(-0.75),
      minWidth: 'auto !important',

      '& .MuiButton-startIcon': {
        display: 'flex',
      },
    },
    buttonLabel: {
      '&.light-theme': lightTheme.buttonLabel,
      '&.dark-theme': darkTheme.buttonLabel,
      display: 'flex',
      fontSize: '14px',
      lineHeight: '14px',
    },
  }),
  { name: 'BackButtonNavigation' },
);

export default useBackButtonNavigationStyles;
